// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellSolidCircle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-solid-circle': IconBellSolidCircle;
    }
}

/**
 * The icon component for the 'bellSolidCircle' icon
 */
export class IconBellSolidCircle extends Icon {
    public constructor() {
        super(bellSolidCircle16X16);
    }
}

registerIcon('icon-bell-solid-circle', IconBellSolidCircle);
export const iconBellSolidCircleTag = 'nimble-icon-bell-solid-circle';
